import React, { Suspense, useEffect } from 'react'
import '../src/globalCSS/style.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import ScrollToTop from './components/ScrollToTop'
import { useDispatch, useSelector } from 'react-redux'
import { general } from './redux/actions/generalActions'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const Homelayouts = React.lazy(() => import('../src/layouts/Homelayouts'))
const Loginlayouts = React.lazy(() => import('../src/layouts/Loginlayout'))
const Userlayouts = React.lazy(() => import('../src/layouts/Userlayout'))
const IndexPage = React.lazy(() => import('../src/pages/index'))

function App() {
  const language = useSelector((state) => state.language)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(general(language))
  }, [language])
  return (
    <BrowserRouter>
      <Suspense fallback={loading}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<IndexPage />} />
          <Route exact path="*" name="homepage" element={<Homelayouts />} />
          <Route path="/login/*" name="Login" element={<Loginlayouts />} />
          <Route exact path="/user/*" name="User" element={<Userlayouts />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
